import {IRoutableModule} from '../../../router/routing.infra';
import {StoreView} from './store.view';
import {storeRouteLoader} from './store.loader';

export default {
    loader: storeRouteLoader,
    Component: StoreView,
    storeAs: 'redirectToStoreStore'
} as IRoutableModule;
